<template>
    <div id="statistics-data">
        <v-card>
            <v-card-title class="pb-0">
                Biographic Stats
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Gender
                        </v-card-subtitle>
                        <v-alert v-if="genderItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent text
                            type="info">
                            There are no statistics data for "Gender".
                        </v-alert>
                        <v-data-table v-else :headers="genderHeaders" :items="genderItems" :items-per-page="3"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Age Range
                        </v-card-subtitle>
                        <v-alert v-if="ageRangeItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent
                            text type="info">
                            There are no statistics data for "Age Range".
                        </v-alert>
                        <v-data-table v-else :headers="ageRangeHeaders" :items="ageRangeItems" :items-per-page="3"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Home City
                        </v-card-subtitle>
                        <v-alert v-if="cityItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent text
                            type="info">
                            There are no statistics data for "Home City".
                        </v-alert>
                        <v-data-table v-else :headers="cityHeaders" :items="cityItems" :items-per-page="10"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Home Country
                        </v-card-subtitle>
                        <v-alert v-if="countryItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent text
                            type="info">
                            There are no statistics data for "Home Country".
                        </v-alert>
                        <v-data-table v-else :headers="countryHeaders" :items="countryItems" :items-per-page="10"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            International Students
                        </v-card-subtitle>
                        <v-alert v-if="internationalItems.length == 0" :color="infoColor" icon="mdi-chart-line"
                            prominent text type="info">
                            There are no statistics data for "International Students".
                        </v-alert>
                        <v-data-table v-else :headers="internationalHeaders" :items="internationalItems"
                            :items-per-page="3" class="elevation-2">
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-5">
            <v-card-title class="pb-0">
                Residence Stats
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Year of Study
                        </v-card-subtitle>
                        <v-alert v-if="yearOfStudyItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent
                            text type="info">
                            There are no statistics data for "Year of Study".
                        </v-alert>
                        <v-data-table v-else :headers="yearOfStudyHeaders" :items="yearOfStudyItems" :items-per-page="3"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Meal Plan
                        </v-card-subtitle>
                        <v-alert v-if="mealPlanItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent
                            text type="info">
                            There are no statistics data for "Meal Plan".
                        </v-alert>
                        <v-data-table v-else :headers="mealPlanHeaders" :items="mealPlanItems" :items-per-page="3"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Building Preferences - Female
                        </v-card-subtitle>
                        <v-alert v-if="buildingPreferencesFemaleItems.length == 0" :color="infoColor"
                            icon="mdi-chart-line" prominent text type="info">
                            There are no statistics data for "Building Preferences - Female".
                        </v-alert>
                        <v-data-table v-else :headers="buildingPreferencesFemaleHeaders"
                            :items="buildingPreferencesFemaleItems" :items-per-page="5" class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Building Preferences - Male
                        </v-card-subtitle>
                        <v-alert v-if="buildingPreferencesMaleItems.length == 0" :color="infoColor"
                            icon="mdi-chart-line" prominent text type="info">
                            There are no statistics data for "Building Preferences - Male".
                        </v-alert>
                        <v-data-table v-else :headers="buildingPreferencesMaleHeaders"
                            :items="buildingPreferencesMaleItems" :items-per-page="5" class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Building Preferences - Other
                        </v-card-subtitle>
                        <v-alert v-if="buildingPreferencesOtherItems.length == 0" :color="infoColor"
                            icon="mdi-chart-line" prominent text type="info">
                            There are no statistics data for "Building Preferences - Other".
                        </v-alert>
                        <v-data-table v-else :headers="buildingPreferencesOtherHeaders"
                            :items="buildingPreferencesOtherItems" :items-per-page="5" class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Lifestyle
                        </v-card-subtitle>
                        <v-alert v-if="lifestyleItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent
                            text type="info">
                            There are no statistics data for "Lifestyle".
                        </v-alert>
                        <v-data-table v-else :headers="lifestyleHeaders" :items="lifestyleItems" :items-per-page="5"
                            class="elevation-2">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card-subtitle class="px-0">
                            Payment Method
                        </v-card-subtitle>
                        <v-alert v-if="lifestyleItems.length == 0" :color="infoColor" icon="mdi-chart-line" prominent
                            text type="info">
                            There are no statistics data for "Payment Method".
                        </v-alert>
                        <v-data-table v-else :headers="paymentMethodHeaders" :items="paymentMethodItems"
                            :items-per-page="5" class="elevation-2">
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'statistics-data',
    props: {
        data: {
            required: true
        }
    },
    data() {
        return {
            ageRangeHeaders: [{
                    text: 'Age',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            buildingPreferencesFemaleHeaders: [{
                    text: 'Building',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'First Choice',
                    value: 'choiceOne'
                },
                {
                    text: 'Second Choice',
                    value: 'choiceTwo'
                },
                {
                    text: 'Third Choice',
                    value: 'choiceThree'
                }
            ],
            buildingPreferencesMaleHeaders: [{
                    text: 'Building',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'First Choice',
                    value: 'choiceOne'
                },
                {
                    text: 'Second Choice',
                    value: 'choiceTwo'
                },
                {
                    text: 'Third Choice',
                    value: 'choiceThree'
                }
            ],
            buildingPreferencesOtherHeaders: [{
                    text: 'Building',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'First Choice',
                    value: 'choiceOne'
                },
                {
                    text: 'Second Choice',
                    value: 'choiceTwo'
                },
                {
                    text: 'Third Choice',
                    value: 'choiceThree'
                }
            ],
            cityHeaders: [{
                    text: 'City',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            countryHeaders: [{
                    text: 'Country',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            genderHeaders: [{
                    text: 'Gender',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            internationalHeaders: [{
                    text: 'International',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            lifestyleHeaders: [{
                    text: 'Lifestyle',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            mealPlanHeaders: [{
                    text: 'Meal Plan',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            paymentMethodHeaders: [{
                    text: 'paymentMethod',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
            yearOfStudyHeaders: [{
                    text: 'Year of Study',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Stats',
                    value: 'value'
                },
            ],
        }
    },
    computed: {
        ageRangeItems() {
            let ageRange = this.data.ageRange && this.data.ageRange.data ? this.data.ageRange : {};
            let ageRangeData = this.data.ageRange.data || [];
            let items = [];

            for (let i = 0; i < ageRangeData.length; i++) {
                let value = `${ageRangeData[i].value}/${ageRange.totalRecordsMeetingCriteria} (${((ageRangeData[i].value / ageRange.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: ageRangeData[i].label,
                    value: value
                });
            }

            return items;
        },
        buildingPreferencesFemaleItems() {
            let buildingPreferencesFemaleData = this.data.buildingPreferencesFemale.data || [];
            let items = [];

            for (let i = 0; i < buildingPreferencesFemaleData.length; i++) {
                let total = buildingPreferencesFemaleData[i]["01"] + buildingPreferencesFemaleData[i]["02"] + buildingPreferencesFemaleData[i]["03"];
                let choiceOne = `${buildingPreferencesFemaleData[i]["01"]}/${total} (${((buildingPreferencesFemaleData[i]["01"] / total) * 100).toFixed(2)}%)`;
                let choiceTwo = `${buildingPreferencesFemaleData[i]["02"]}/${total} (${((buildingPreferencesFemaleData[i]["02"] / total) * 100).toFixed(2)}%)`;
                let choiceThree = `${buildingPreferencesFemaleData[i]["03"]}/${total} (${((buildingPreferencesFemaleData[i]["03"] / total) * 100).toFixed(2)}%)`;
                items.push({
                    choiceOne: choiceOne,
                    choiceTwo: choiceTwo,
                    choiceThree: choiceThree,
                    name: buildingPreferencesFemaleData[i].label
                });
            }

            return items;
        },
        buildingPreferencesMaleItems() {
            let buildingPreferencesMaleData = this.data.buildingPreferencesMale.data || [];
            let items = [];

            for (let i = 0; i < buildingPreferencesMaleData.length; i++) {
                let total = buildingPreferencesMaleData[i]["01"] + buildingPreferencesMaleData[i]["02"] + buildingPreferencesMaleData[i]["03"];
                let choiceOne = `${buildingPreferencesMaleData[i]["01"]}/${total} (${((buildingPreferencesMaleData[i]["01"] / total) * 100).toFixed(2)}%)`;
                let choiceTwo = `${buildingPreferencesMaleData[i]["02"]}/${total} (${((buildingPreferencesMaleData[i]["02"] / total) * 100).toFixed(2)}%)`;
                let choiceThree = `${buildingPreferencesMaleData[i]["03"]}/${total} (${((buildingPreferencesMaleData[i]["03"] / total) * 100).toFixed(2)}%)`;
                items.push({
                    choiceOne: choiceOne,
                    choiceTwo: choiceTwo,
                    choiceThree: choiceThree,
                    name: buildingPreferencesMaleData[i].label
                });
            }

            return items;
        },
        buildingPreferencesOtherItems() {
            let buildingPreferencesOtherData = this.data.buildingPreferencesOther.data || [];
            let items = [];

            for (let i = 0; i < buildingPreferencesOtherData.length; i++) {
                let total = buildingPreferencesOtherData[i]["01"] + buildingPreferencesOtherData[i]["02"] + buildingPreferencesOtherData[i]["03"];
                let choiceOne = `${buildingPreferencesOtherData[i]["01"]}/${total} (${((buildingPreferencesOtherData[i]["01"] / total) * 100).toFixed(2)}%)`;
                let choiceTwo = `${buildingPreferencesOtherData[i]["02"]}/${total} (${((buildingPreferencesOtherData[i]["02"] / total) * 100).toFixed(2)}%)`;
                let choiceThree = `${buildingPreferencesOtherData[i]["03"]}/${total} (${((buildingPreferencesOtherData[i]["03"] / total) * 100).toFixed(2)}%)`;
                items.push({
                    choiceOne: choiceOne,
                    choiceTwo: choiceTwo,
                    choiceThree: choiceThree,
                    name: buildingPreferencesOtherData[i].label
                });
            }

            return items;
        },
        cityItems() {
            let city = this.data.city && this.data.city.data ? this.data.city : {};
            let cityData = this.data.city.data || [];
            let items = [];

            for (let i = 0; i < cityData.length; i++) {
                let value = `${cityData[i].value}/${city.totalRecordsMeetingCriteria} (${((cityData[i].value / city.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: cityData[i].label,
                    value: value
                });
            }

            return items;
        },
        countryItems() {
            let country = this.data.country && this.data.country.data ? this.data.country : {};
            let countryData = this.data.country.data || [];
            let items = [];

            for (let i = 0; i < countryData.length; i++) {
                let value = `${countryData[i].value}/${country.totalRecordsMeetingCriteria} (${((countryData[i].value / country.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: countryData[i].label,
                    value: value
                });
            }

            return items;
        },
        genderItems() {
            let gender = this.data.gender && this.data.gender.data ? this.data.gender : {};
            let genderData = this.data.gender.data || [];
            let items = [];

            for (let i = 0; i < genderData.length; i++) {
                let label = genderData[i].label.charAt(0).toUpperCase() + genderData[i].label.slice(1);
                let value = genderData[i].value ? `${genderData[i].value}/${gender.totalRecordsMeetingCriteria} (${((genderData[i].value / gender.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)` : 'N/A';
                items.push({
                    name: label,
                    value: value
                });
            }

            return items;
        },
        internationalItems() {
            let international = this.data.international && this.data.international.data ? this.data.international : {};
            let internationalData = this.data.international.data || [];
            let items = [];

            for (let i = 0; i < internationalData.length; i++) {
                let value = `${internationalData[i].value}/${international.totalRecordsMeetingCriteria} (${((internationalData[i].value / international.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: internationalData[i].label,
                    value: value
                });
            }

            return items;
        },
        lifestyleItems() {
            let lifestyle = this.data.lifestyle && this.data.lifestyle.data ? this.data.lifestyle : {};
            let lifestyleData = this.data.lifestyle.data || [];
            let items = [];

            for (let i = 0; i < lifestyleData.length; i++) {
                let value = `${lifestyleData[i].value}/${lifestyle.totalRecordsMeetingCriteria} (${((lifestyleData[i].value / lifestyle.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: lifestyleData[i].label,
                    value: value
                });
            }

            return items;
        },
        mealPlanItems() {
            let mealPlan = this.data.mealPlan && this.data.mealPlan.data ? this.data.mealPlan : {};
            let mealPlanData = this.data.mealPlan.data || [];
            let items = [];

            for (let i = 0; i < mealPlanData.length; i++) {
                let value = `${mealPlanData[i].value}/${mealPlan.totalRecordsMeetingCriteria} (${((mealPlanData[i].value / mealPlan.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: mealPlanData[i].label,
                    value: value
                });
            }

            return items;
        },
        paymentMethodItems() {
            let paymentMethod = this.data.paymentMethod && this.data.paymentMethod.data ? this.data.paymentMethod : {};
            let paymentMethodData = this.data.paymentMethod.data || [];
            let items = [];

            for (let i = 0; i < paymentMethodData.length; i++) {
                let value = `${paymentMethodData[i].value}/${paymentMethod.totalRecordsMeetingCriteria} (${((paymentMethodData[i].value / paymentMethod.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: paymentMethodData[i].label,
                    value: value
                });
            }

            return items;
        },
        yearOfStudyItems() {
            let yearOfStudy = this.data.yearOfStudy && this.data.yearOfStudy.data ? this.data.yearOfStudy : {};
            let yearOfStudyData = this.data.yearOfStudy.data || [];
            let items = [];

            for (let i = 0; i < yearOfStudyData.length; i++) {
                let value = `${yearOfStudyData[i].value}/${yearOfStudy.totalRecordsMeetingCriteria} (${((yearOfStudyData[i].value / yearOfStudy.totalRecordsMeetingCriteria) * 100).toFixed(2)}%)`;
                items.push({
                    name: yearOfStudyData[i].label,
                    value: value
                });
            }

            return items;
        },
        infoColor() {
            return '#5578eb';
        }
    }
}
</script>